import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import {
  GetFolderIdByName,
  GetFolderContent,
  DownloadFile,
  setState,
} from "../analyzeSlice";
import FolderIcon from "@mui/icons-material/Folder";
import HouseIcon from "@mui/icons-material/House";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import GridOnIcon from "@mui/icons-material/GridOn";
import DownloadIcon from "@mui/icons-material/Download";
import CollapseSection from "../../../components/ui/CollapseSection";

export default function DownloadFiles() {
  const homeFolderName = "UI_Download";
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const { getFolderIdByName, getFolderContent } = state;

  const [breadcrumb, setBreadcrumb] = useState("");
  const [parentFolderList, setParentFolderList] = useState("");
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({
    notfound: false,
  });

  useEffect(() => {
    let obj = {
      FolderName: "UI_Download",
    };

    dispatch(GetFolderIdByName(obj));
  }, [homeFolderName]);

  useEffect(() => {
    if (getFolderIdByName.length > 0) {
      let obj = {
        method: "GET",
        id: getFolderIdByName,
      };

      setParentFolderList(getFolderIdByName);
      dispatch(GetFolderContent(obj));
    }
  }, [getFolderIdByName]);

  function handleParentFolder() {
    let obj = {
      method: "GET",
      id: getFolderIdByName,
    };

    dispatch(GetFolderContent(obj));

    setColumnVisibilityModel({ notfound: false });
    setBreadcrumb("");
  }

  function handleChildFolder() {
    let selectedFolderID = getFolderIdByName;
    const withoutLastBreadcrumb = breadcrumb.slice(
      0,
      breadcrumb.lastIndexOf("/")
    );

    setBreadcrumb(withoutLastBreadcrumb);

    const withoutLastId = parentFolderList.slice(
      0,
      parentFolderList.lastIndexOf(",")
    );

    setParentFolderList(withoutLastId);
    const myarray = withoutLastId.split(",");

    selectedFolderID = myarray[myarray.length - 1];

    let obj = {
      method: "GET",
      id: selectedFolderID,
    };

    dispatch(GetFolderContent(obj));

    if (selectedFolderID == getFolderIdByName) {
      setColumnVisibilityModel({ notfound: false });
    }
  }

  function setRowSelectionModel(params) {
    let id = params.row.id;
    let field = params.field;
    let type = params.row.type;
    let fileName = params.row.name;

    if (field == "name" && type == "Folder") {
      if (id) {
        const selectedRowsData = getFolderContent.find((row) => row.id === id);
        let name = breadcrumb + "/" + selectedRowsData["name"];
        let parentId = parentFolderList + "," + id;
        setBreadcrumb(name);
        setParentFolderList(parentId);
        setColumnVisibilityModel({ notfound: true });

        let obj = {
          method: "GET",
          id: id,
        };

        dispatch(GetFolderContent(obj));
      }
    }

    if (field == "path" && type == "File") {
      let obj = {
        method: "GET",
        fileId: id,
        fileName: fileName,
      };

      dispatch(DownloadFile(obj));
    }
  }

  const columns = [
    {
      field: "notfound",
      sortable: false,
      renderHeader: () => (
        <div>
          <HouseIcon
            fontSize="large"
            onClick={handleParentFolder}
            sx={{ color: "#007dc3" }}
          />
          <KeyboardReturnIcon
            fontSize="large"
            onClick={handleChildFolder}
            sx={{
              color: "#007dc3",
              transform: "rotate(90deg)",
            }}
          />
        </div>
      ),
      flex: 2,
    },
    {
      field: "name",
      headerName: "Name",
      flex: 12,
      renderCell: (params) => {
        let name = params.row.name;
        if (params.row.type == "Folder") {
          return (
            <div style={{ cursor: "pointer" }}>
              <FolderIcon sx={{ color: "#f8d775", cursor: "pointer", transform: "translate(0px, 6px)",mr: .5, }} />
              <span style={{}}>&nbsp;{params.row.name}</span>
            </div>
          );
        } else {
          if (name.includes(".zip")) {
            return (
              <div>
                <InsertDriveFileIcon sx={{ color: "green.main" }} />
                <span>{params.row.name}</span>;
              </div>
            );
          } else if (name.includes(".xls")) {
            return (
              <div>
                <GridOnIcon sx={{ color: "green.main" }} />
                <span>{params.row.name}</span>;
              </div>
            );
          } else {
            <span>{params.row.name}</span>;
          }
        }
      },
    },
    {
      field: "lastUpdateTime",
      headerName: "Last Modified on",
      flex: 4,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return <span>{params.row.lastUpdateTime}</span>;
        } else return <span></span>;
      },
      clickable: false,
    },
    {
      field: "size",
      headerName: "Size",
      flex: 2,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return <span>{params.row.size}</span>;
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
    {
      field: "path",
      headerName: "Download",
      flex: 3,
      renderCell: (params) => {
        if (params.row.type == "File") {
          return (
            <div>
              <DownloadIcon sx={{ color: "green.main", cursor: "pointer" }} />
            </div>
          );
        } else return <span></span>;
      },
      clickable: false,
      sortable: false,
    },
  ];

  return (
    <div>
      <CollapseSection title="Download Files">
        <Box mt={1}>
          <Box>
            <h5 sx={{ color: "007dc3" }}>Path:{breadcrumb}</h5>
          </Box>
          <Box mt={2} sx={{ width: "100%" }}>
            <DataGrid
              disableColumnMenu
              rows={getFolderContent || []}
              columns={columns}
              getRowId={(row) => row?.id}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 5,
                  },
                },
              }}
              pageSizeOptions={[5]}
              onCellClick={setRowSelectionModel}
              //disableRowSelectionOnClick
              // onRowSelectionModelChange={(newRowSelectionModel) => {
              //   setRowSelectionModel(newRowSelectionModel);
              // }}
              columnVisibilityModel={columnVisibilityModel}
            />
          </Box>
        </Box>
      </CollapseSection>
    </div>
  );
}
